import axios from "../../axios-amps";
import { serverconfigs } from "../../constants";
import { logFirebaseEvent } from "../../shared/utility";
import * as actionTypes from "./actionTypes";
import { parseAccessToken } from ".";
export const fetchAppConfigSuccess = (
  appConfig,
  config_values,
  isWatermark
) => ({
  type: actionTypes.FETCH_APP_CONFIG_SUCCESS,
  appConfig,
  config_values,
  isWatermark,
});
export const fetchAppConfigFailed = (error) => ({
  type: actionTypes.FETCH_APP_CONFIG_FAILED,
  payload: error,
});
export const fetchAppConfigStarted = () => ({
  type: actionTypes.FETCH_APP_CONFIG_STARTED,
});
export const parseAppConfigData = (appConfig) => {
  const { result = [] } = appConfig;
  console.log("result parseAppConfigData", result);
  let modules = [];
  let logos = [];
  let client = "amps";
  let modulesObj = result.find((res) => res.type.toLowerCase() === "modules");
  console.log("modulesObj parseAppConfigData", modulesObj);

  if (modulesObj && modulesObj.client) {
    client = modulesObj.client;
    localStorage.setItem("client", modulesObj.client);
    console.log("result client", client);
  }
  if (modulesObj && modulesObj.client_group_id) {
    localStorage.setItem("clientGroupId", modulesObj.client_group_id);
  }
  if (modulesObj && modulesObj.clientid) {
    localStorage.setItem("clientId", modulesObj.clientid);
  }
  // Removing Themes for Trust Mark
  // const theme = client.toLowerCase().match(/rust/g) ? "trustMark" : "amps";
  const theme = client.toLowerCase().match(/rust/g) ? "amps" : "amps";
  console.log("theme", theme);

  /*fetching client logo */
  let logosObj = result.find((res) => res.type.toLowerCase().match(/logo/g));
  console.log("modulesObj parseAppConfigData", logosObj);
  if (logosObj && logosObj.config) {
    logos = logosObj.config;
    console.log("result logos", logos);
  }

  return { modules, theme, logos };
};
export const fetchAppConfig = (userId: string, language: string) => {
  console.log("fetchAppConfig", language);

  return (dispatch) => {
    dispatch(fetchAppConfigStarted());
    axios
      .get(serverconfigs.appConfigUrl + `${userId}?lang=` + language)
      .then((response) => {
        console.log(response);
        const appConfig = parseAppConfigData(response.data);
        console.log("appConfig", appConfig);
        dispatch(
          fetchAppConfigSuccess(
            appConfig,
            response.data.config_values,
            response.data.isWatermark
          )
        );
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchAppConfigFailed(error));
      });
  };
};

export const setUserImpersonation = (userId) => {
  return {
    type: actionTypes.CAN_USER_IMPERSONATE_SUCCESS,
    value: userId,
  };
};
export const fetchCanUserImpersonateFailed = (error) => {
  return {
    type: actionTypes.CAN_USER_IMPERSONATE_FAILED,
    payload: error,
  };
};

export const fetchCanUserImpersonate = (userId) => {
  return (dispatch) => {
    axios
      .get(serverconfigs.canImpersonate + `?userId=${userId}`)
      .then((response) => {
        dispatch(setUserImpersonation(response.data));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchCanUserImpersonateFailed(error));
      });
  };
};

export const setUserImpersonationToken = (token) => {
  console.log("respo", token);
  if (token != null) {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("impersonate");
    window.location.href = token;
  }
};
export const setUserImpersonationTokenFailed = (error) => {
  return {
    type: actionTypes.IMPERSONATED_USER_TOKEN_FAILED,
    payload: error,
  };
};
export const fetchImpersonatedUserToken = (userId, userEmail) => {
  return (dispatch) => {
    axios
      .get(
        serverconfigs.getImpersonatedUserToken +
          `${userId}?userEmail=${userEmail}`
      )
      .then((response) => {
        dispatch(setUserImpersonationToken(response.data));
        return true;
      })
      .catch((error) => {
        if (error.response.data.status == 409) {
          dispatch(setUserImpersonationTokenFailed("User does not exist"));
        }
      });
  };
};
